import { ChangeDetectionStrategy, Component, Inject, ViewChild, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { CollabSchema } from '@common/prosemirror/model/collab-schema';
import { dirname, relative } from '@common/util/path';
import { LicenseUser } from '@portal-core/license-users/models/license-user.model';
import { ProjectFilesTreeItemPreviewComponent } from '@portal-core/project-files/components/project-files-tree-item-preview/project-files-tree-item-preview.component';
import { SnippetFileFilter } from '@portal-core/project-files/constants/file-filters.constants';
import { ProjectFolder } from '@portal-core/project-files/enums/project-folder.enum';
import { DialogBase } from '@portal-core/ui/dialog/util/dialog.base';

export interface ProjectFilesAddSnippetDialogData {
  commitId: string;
  projectId: number;
  branchName: string;
  filePath: string;
  licenseUser: LicenseUser;
  projectLanguage: string;
  schema: CollabSchema;
  usingWorkspaceTree?: boolean;
}

export interface ProjectFilesAddSnippetDialogResult {
  path: string;
  isInlineContent: boolean;
}

@Component({
  selector: 'mc-project-files-add-snippet-dialog',
  templateUrl: './project-files-add-snippet-dialog.component.html',
  styleUrls: ['./project-files-add-snippet-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProjectFilesAddSnippetDialogComponent extends DialogBase {
  static DialogConfig: MatDialogConfig = {
    width: '85rem',
    height: '46rem'
  };

  @ViewChild('snippetPreview', { static: true }) snippetPreview: ProjectFilesTreeItemPreviewComponent;

  ProjectFolder: typeof ProjectFolder = ProjectFolder;
  treeFileFilter: string = SnippetFileFilter;

  constructor(
    protected dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any,
    protected dialogRef: MatDialogRef<ProjectFilesAddSnippetDialogComponent>
  ) {
    super(dialog, dialogRef);
  }

  onInsertClicked(snippetPath: string) {
    if (!snippetPath) {
      return;
    }

    // Examine the snippet content for a block node to help determine if it should be a snippetBlock or snippetText node
    const doc = this.snippetPreview.snippetPreviewEditor.editorState.doc;

    let isInlineContent = true;
    doc.descendants(node => {
      if (node.type.name === 'body') {
        isInlineContent = node.childCount === 1 && (node.firstChild.isInline || node.firstChild.type === this.data.schema.nodes.mcCentralContainer); // mcCentralContainers are just our block wrapping for inline content
        return false;
      }
    });

    const relativeSrc: string = relative(dirname(this.data.filePath), snippetPath);

    const result: ProjectFilesAddSnippetDialogResult = { path: relativeSrc, isInlineContent: isInlineContent };
    this.closeDialog(result);
  }
}
